// Action keys for executeAction calls
export const SERVICE_CASE_CREATE_ORDER_ACTION = 'service-case/create-order';
export const SERVICE_CASE_CANCEL_ACTION = 'service-case/cancel';
export const SERVICE_CASE_REOPEN_ACTION = 'service-case/reopen';
